import {executeWithIntercept, onRedirect, pageData, RouteData} from "@/helpers/CypressHelper";
import Localizer from "@/localization/Localizer";
import {Method} from "cypress/types/net-stubbing";

describe('Desktop - Construction Site - status page test', () => {

    beforeEach(() => {
        cy.useSharedAdminUserSession();
    });

    Cypress.on('uncaught:exception', (err, runnable) => {
        return false;
    });

    function intercept(func: { path: string; method: string }, file: string): void {
        cy.intercept(func.method as Method, func.path, {fixture: file});
    }

    it('Emissions - Should render emission chart with localized data', () => {
        const {emissions} = pageData().constructionSite.status.routes;
        intercept(emissions, 'status/emissions.json')

        onRedirect(() => {
            executeWithIntercept(() =>
                    cy.visit(`${Localizer.pageRoutesConstructionSiteDetails}?id=f7422461-9c46-416d-b500-7ab6ae1ee591`),
                [pageData().constructionSite.routes.getConstructionSiteDetails as RouteData]
            );
        });

        pageData().constructionSite.status.tab().click();

        pageData().constructionSite.status.emissionContainer().should("exist");

        pageData().constructionSite.status.emissionContainer().find('h2').should('have.text', Localizer.constructionSiteDetailsCo2Emissions);

        pageData().constructionSite.status.emissionContainer().find('[data-cy=renta-line-chart-container]').should('exist');

        cy.get('[data-cy="status-co2-emission-chart-no-data"]').should('not.exist');
    });

    it('Emissions - Should display friendly no data message', () => {
        const {emissions} = pageData().constructionSite.status.routes;
        intercept(emissions, 'status/noData.json')

        onRedirect(() => {
            executeWithIntercept(() =>
                    cy.visit(`${Localizer.pageRoutesConstructionSiteDetails}?id=f7422461-9c46-416d-b500-7ab6ae1ee591`),
                [pageData().constructionSite.routes.getConstructionSiteDetails as RouteData]
            );
        });

        pageData().constructionSite.status.tab().click();

        pageData().constructionSite.status.emissionContainer().should("exist");

        pageData().constructionSite.status.emissionContainer().find('h2').should('have.text', Localizer.constructionSiteDetailsCo2Emissions);

        cy.get('[data-cy="status-co2-emission-chart-no-data"]').should('exist');
    });

    it('Rental cost - Should render rental costs chart with localized data', () => {
        const {getRentalCosts} = pageData().constructionSite.status.routes;
        intercept(getRentalCosts, 'status/getRentalCosts.json')

        onRedirect(() => {
            executeWithIntercept(() =>
                    cy.visit(`${Localizer.pageRoutesConstructionSiteDetails}?id=f7422461-9c46-416d-b500-7ab6ae1ee591`),
                [pageData().constructionSite.routes.getConstructionSiteDetails as RouteData]
            );
        });

        pageData().constructionSite.status.tab().click();

        cy.get("#status-rental-costs-chart-container").should("exist");

        cy.get("#status-rental-costs-chart-container").find('h2').should('have.text', Localizer.constructionSiteDetailsStatusRentalCostsTitle);

        cy.get("#status-rental-costs-chart-container").find('[data-cy=renta-line-chart-container]').should('exist');

        cy.get('[data-cy="status-rental-costs-chart-no-data"]').should('not.exist');
    });

    it('Rental cost - Should display friendly no data message', () => {
        const {getRentalCosts} = pageData().constructionSite.status.routes;
        intercept(getRentalCosts, 'status/noData.json')

        onRedirect(() => {
            executeWithIntercept(() =>
                    cy.visit(`${Localizer.pageRoutesConstructionSiteDetails}?id=f7422461-9c46-416d-b500-7ab6ae1ee591`),
                [pageData().constructionSite.routes.getConstructionSiteDetails as RouteData]
            );
        });

        pageData().constructionSite.status.tab().click();

        cy.get("#status-rental-costs-chart-container").should("exist");

        cy.get("#status-rental-costs-chart-container").find('h2').should('have.text', Localizer.constructionSiteDetailsStatusRentalCostsTitle);

        cy.get('[data-cy="status-rental-costs-chart-no-data"]').should('exist');
    });
});
